
import "./App.css";
import Main from "./Component/Main"
import AllRoute from "./Component/AllRoutes";
import Footer from "./Component/Footer";
// import SimpleSlider from "./Page/";
// import SimpleSliderHome from "./Page/CarouselHome";


function App() {
  return (
    <div className="App">
      <Main/>
      <AllRoute/>
      
      
      <Footer/>
     {/* <SimpleSliderHome/> */}
    </div>
  );
}

export default App;
